export const ASSESSOR_EDIT_ENSINO_SUPERIOR_INCOMPLETO = 0;
export const ASSESSOR_EDIT_ENSINO_SUPERIOR_COMPLETO = 1;
export const ASSESSOR_EDIT_ESPECIALIZACAO_INCOMPLETA = 2;
export const ASSESSOR_EDIT_ESPECIALIZACAO_COMPLETA = 3;
export const ASSESSOR_EDIT_MESTRADO_INCOMPLETO = 4;
export const ASSESSOR_EDIT_MESTRADO_COMPLETO = 5;
export const ASSESSOR_EDIT_DOUTORADO_INCOMPLETO = 6;
export const ASSESSOR_EDIT_DOUTORADO_COMPLETO = 7;

const allFormacaoAcademica = [];
allFormacaoAcademica[ASSESSOR_EDIT_ENSINO_SUPERIOR_INCOMPLETO] = {
  name: 'Ensino Superior Incompleto',
};
allFormacaoAcademica[ASSESSOR_EDIT_ENSINO_SUPERIOR_COMPLETO] = {
  name: 'Ensino Superior Completo',
};
allFormacaoAcademica[ASSESSOR_EDIT_ESPECIALIZACAO_INCOMPLETA] = {
  name: 'Especialização Incompleta',
};
allFormacaoAcademica[ASSESSOR_EDIT_ESPECIALIZACAO_COMPLETA] = {
  name: 'Especialização Completa',
};
allFormacaoAcademica[ASSESSOR_EDIT_MESTRADO_INCOMPLETO] = {
  name: 'Mestrado Incompleto',
};
allFormacaoAcademica[ASSESSOR_EDIT_MESTRADO_COMPLETO] = {
  name: 'Mestrado Completo',
};
allFormacaoAcademica[ASSESSOR_EDIT_DOUTORADO_INCOMPLETO] = {
  name: 'Doutorado Incompleto',
};
allFormacaoAcademica[ASSESSOR_EDIT_DOUTORADO_COMPLETO] = {
  name: 'Doutorado Completo',
};

function getName(index) {
  if (index < allFormacaoAcademica.length) {
    return allFormacaoAcademica[index].name;
  }
  return null;
}

export { allFormacaoAcademica, getName };
